import React from 'react';
const LocaleContext = /*#__PURE__*/React.createContext(null);
export default LocaleContext;